import { ReactNode } from 'react'

export interface Props {
  theme?: 'info' | 'success' | 'warning' | 'error'
  children: ReactNode
}

export const useAlert = (props: Props) => {
  const { theme = 'info', children } = props

  return {
    theme,
    children,
  }
}
